<kl-grid-container
  [data]="gridRows()"
  [columns]="columns()"
  [authNum]="authNum()"
  [showButton]="showButton()"
  [showToolbar]="showToolbar()"
  [doAdd]="doAdd()"
  [doEdit]="doEdit()"
  [doView]="doView()"
  [doDelete]="doDelete()"
  [doRefresh]="doRefresh()"
  [doExport]="doExport()"
  [doBulkDelete]="doBulkDelete()"
  [doOther]="doOther()"
  [disabledButton]="disabledButton()"
  [deferResizing]="deferResizing()"
  [sortable]="sortable()"
  [filterable]="filterable()"
  [columnFilters]="columnFilters()"
  [columnReorderEnabled]="columnReorderEnabled()"
  [columnResizeEnabled]="columnResizeEnabled()"
  [showGridSearch]="showGridSearch()"
  [haveHistory]="haveHistory()"
  [doInfo]="doInfo()"
  [customFilter]="customFilter()"
  [fullscreen]="fullscreen()"
  [doDesign]="doDesign()"
  [multi_select]="multi_select()"
  [dblSelect]="dblSelect()"
  [actions]="actions()"
  [processesActions]="processesActions()"
  [customToolbar]="customToolbar()"
  [customToolbarVisible]="customToolbarVisible()"
  [actionRefresh]="gridActionContext.refresh"
  [actionGridLoading]="gridActionContext.gridLoading"
  [actionShowAlert]="gridActionContext.showAlert"
  [actionHandleError]="gridActionContext.handleError"
  [initStatesWithoutChild]="initStatesWithoutChild()"
  [initStatesWithChild]="initStatesWithChild()"
  [gridDataKey]="gridDataKey()"
  [rowExpandMode]="rowExpandMode()"
  [gridHeaderName]="endpointConfig().name ?? ''"
  [endpointName]="endpointConfig().endpoint"
  [designParentModule]="designParentModule()"
  [designModule]="designModule()"
  [designKey]="designKey()"
  [filterSelectItems]="filterSelectItems()"
  [alertShow]="alertShow()"
  [alertType]="alertType()"
  [alertMessage]="alertMessage()"
  [autoClose]="autoClose()"
  [loading]="gridDataLoading()"
  [loadingText]="gridLoadingText()"
  [recordFetchLoading]="recordFetchLoading()"
  [pageSize]="pageSize()"
  [totalRecords]="totalCount()"
  [pageFirst]="pageOffset()"
  [showTablePaginator]="gridRows().length > 0"
  [virtualScroll]="virtualScroll()"
  [virtualScrollItemSize]="virtualScrollItemSize()"
  (tablePageChange)="onTablePaginatorChange($event)"
  (editCell)="editRecord()"
  (dblClickEditCell)="dblClickCall()"
  (viewCell)="viewRecord()"
  (deleteCell)="deleteRecord()"
  (bulkDelete)="bulkDeleteRecords($event)"
  (newRecord)="addRecord($event)"
  (filterApplied)="onFilter($event)"
  (customFilterEvent)="onCustomFilterEvent.emit($event)"
  (refreshGrid)="refresh()"
  (exportGrid)="onExport($event)"
  (closeAlert)="closeAlert()"
  (selectionChange)="selectionChange.emit($event)"
  (rowAction)="rowAction.emit($event)"
  (infoCell)="infoRecord($event)"
  (recordHistoryCell)="recordHistory($event)"
  [rowExpansionTemplate]="rowDetailTpl()?.templateRef ?? null" />

@if (gridRows().length && hasPageLimitBox()) {
  <div class="grid-footer">
    <div class="page-limit-box">
      <input
        type="text"
        class="page-limit-input"
        inputmode="numeric"
        maxlength="3"
        [value]="pageSize()"
        (keydown.enter)="pageSize.set(+$any($event.target).value); refresh()"
        (focusout)="pageSize.set(+$any($event.target).value); refresh()" />
    </div>
  </div>
}
